import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/promo/actions/appAction';
import { setExtra } from 'apps/promo/actions/extraAction';
import { updatePageMessages } from 'apps/promo/actions/messageAction';
import { CommonPagePromo } from 'apps/promo/components/common/CommonPagePromo';
import { LightNavBar } from 'apps/promo/components/common/fromAuth/LightNavBar/LightNavBar';
import LogoPurple from 'apps/promo/components/common/logo-purple/LogoPurple';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import Loading from 'apps/promo/components/utils/Loading';
import { EMAIL_UNSUBSCRIBE_CONFIRM } from 'apps/promo/constants/UrlConstants';
import { apiFetchData } from 'apps/promo/helpers/api';

import UnsubscribeSuccess from './UnsubscribeSuccess';

const Unsubscribe = (props) => {
    const [showSuccess, setShowSuccess] = useState(props.isShowSuccess);

    useEffect(() => {
        setShowSuccess(props.isShowSuccess);
    }, [props.isShowSuccess]);

    if (props.landing) {
        return <Loading />;
    }

    const unsubscribe = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(`${EMAIL_UNSUBSCRIBE_CONFIRM}${props.code}`)
            .then((json) => {
                if (json) {
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    if (json.extra) {
                        props.setExtra(json.extra);
                    }
                }
                props.toggleSpinner(false);
            })
            .catch(() => props.toggleSpinner(false));
    };

    return (
        <CommonPagePromo>
            <LightNavBar align="left">
                <LogoPurple lang={props.lang} country={props.country} />
            </LightNavBar>
            {!showSuccess && (
                <PromoInfoPage
                    iconName="mail-cross-80"
                    iconColor="primary"
                    headerText={props.emailUnsubscribeTitle}
                    secondaryText={props.emailUnsubscribeText}
                    primaryButtonCaption={props.emailUnsubscribeButton}
                    primaryButtonType="link"
                    primaryButtonLink={`${EMAIL_UNSUBSCRIBE_CONFIRM}${props.code}`}
                    primaryButtonOnClick={unsubscribe}
                />
            )}
            {showSuccess && <UnsubscribeSuccess />}
        </CommonPagePromo>
    );
};
const mapStateToProps = (state) => {
    return {
        emailUnsubscribeTitle: state.messages.pageMessages.emailUnsubscribeTitle,
        emailUnsubscribeText: state.messages.pageMessages.emailUnsubscribeText,
        emailUnsubscribeButton: state.messages.pageMessages.emailUnsubscribeButton,
        code: state.extra.code,
        isShowSuccess: state.extra.isShowSuccess,
        lang: state.language.lang,
        country: state.app.country,
    };
};

export default connect(mapStateToProps, {
    updatePageMessages,
    setExtra,
    toggleSpinner,
})(BasePageForNoAuth(Unsubscribe));
